import { Fill, Text } from 'ol/style';
import Style from 'ol/style/Style';
import { FontName, HorizontalAlign } from '@/components/Map/MapViewer/MapViewer.types';
import { getFontName } from '@/components/Map/MapViewer/utils/mapElementsRendering/text/getFontName';

export default function getTextStyle({
  text,
  fontSize,
  color,
  zIndex,
  horizontalAlign,
  fontNameEnum,
  overflow = true,
}: {
  text: string;
  fontSize: number;
  fontNameEnum: FontName;
  color: string;
  zIndex: number;
  horizontalAlign: HorizontalAlign;
  overflow?: boolean;
}): Style {
  const fontName = getFontName(fontNameEnum);
  return new Style({
    text: new Text({
      text,
      font: `${fontSize}pt ${fontName}`,
      fill: new Fill({
        color,
      }),
      placement: 'point',
      textAlign: horizontalAlign.toLowerCase() as CanvasTextAlign,
      textBaseline: 'middle',
      overflow,
    }),
    zIndex,
  });
}
